import { createDepict } from "@frend-digital/depict/server";

export const depict = createDepict({
	merchant: "viking",
});
